import React from 'react'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import InputControl from '../../components/InputControl'
import { Controller, useForm } from 'react-hook-form'
import { Link,useNavigate,useParams } from 'react-router-dom'
import { countrymanagement, industrymanagement } from '../../Routes/routingConsts'
import { Dropdown, Form, InputGroup ,Button} from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import Swal from 'sweetalert2'
const AddNewCountry = () => {
    const countryValidationInput = yup.object({
        name:yup.string().required('Please enter country name')
    })
    const {
        handleSubmit,
        reset,
        register,
        control,
        formState: { errors }
    } = useForm({resolver:yupResolver(countryValidationInput)})
    const navigate = useNavigate()
    const {countryId} = useParams()
   


// add - edit industry ///
async function addIndustry(payload){
    if(countryId){
        return await requestApi.post(`country/add-edit`,{countryId,...payload},{headers:true})
        .then((res)=>{return res.data})
    }
   else{
    return await requestApi.post(`country/add-edit`,payload,{headers:true})
    .then((res)=>{return res.data})
   }
}

const mutation = useMutation(addIndustry, {
    onSuccess: ( data ) => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: '',
            text: data?.meta?.message
        }).then(() => {
            navigate(countrymanagement)
        })
    },
    onError: (error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: '',
            text: error?.message
        })
    }
})
// End add-edit industry////


    // view-industry on id //
    async function viewCountryOnId(countryId) {
        return await requestApi
            .post(
                `/country/view`,
                { countryId: countryId },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['view-country'],
        queryFn: () => viewCountryOnId(countryId),
        enabled: !!countryId,
        onSuccess: (data) => {
            reset({
                name:data?.data?.countryName
            }) 
        }
    })
    // end view industry on id //



 const onSubmit = ({ ...data }) => {
        const payload = {
            ...data,
        }

        mutation.mutate(payload)
    }
    return (
        <>
            <div className="sidebar-content">
                <ul className="nav-links">
                    <Link to={countrymanagement}>
                        <li>
                            <a href="">Country Management</a>
                            <span>&gt;</span>
                        </li>
                    </Link>
                    <li>
                        {countryId ? (
                            <a className="bold">
                                Edit Country
                            </a>
                        ) : (
                            <a className="bold">
                                Add  Country
                            </a>
                        )}
                    </li>
                </ul>

                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="whitebox">
                        {countryId ? (
                        <div className="title-text">
                            <h3>Edit Country</h3>
                        </div>
                    ) : (
                        <div className="title-text">
                            <h3>Add  Country</h3>
                        </div>
                    )}

                        <div className="createnew-box">
                            <div className="row">
                                <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="Country Name"
                                            name="name"
                                            // placeholder="Country"
                                            register={register}
                                            error={errors?.name?.message}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="whitebox"> */}
                    <div className="jobdes-btn">
                        <ButtonWithLoader
                            isLoading={mutation?.isLoading}
                            cssClass="common-btn comman-auth-btn reset-btn"
                        >
                            {countryId ? (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Edit
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Add
                                </button>
                            )}
                        </ButtonWithLoader>
                        <button
                            type="button"
                            className="common-btn cancel"
                            onClick={()=>{navigate(countrymanagement)}}
                        >
                            Cancel
                        </button>
                    </div>
                    {/* </div> */}
                </Form>
            </div>
        </>
    )
}

export default AddNewCountry
